import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'h-10 w-full rounded-md border border-border bg-surface px-3 text-sm text-ink placeholder:text-placeholder',
        'focus:border-brand-outline focus:outline-none focus:ring-2 focus:ring-brand-100',
        'disabled:cursor-not-allowed disabled:bg-surface-muted',
        className,
        invalid && 'border-flag-danger focus:border-flag-danger focus:ring-red-100',
      )}
      {...props}
    />
  );
});
